import type { PlacementId } from './api/api.autogenerated.js';

export type ExperimentName = string;

export type ExperimentPlacement = {
  enabled: boolean;
  placementId: PlacementId;
};

export type AmplitudeExperiments = {
  experiments: {
    [K in ExperimentName]?: ExperimentVariants;
  };

  payloads: {
    [K in ExperimentName]?: {
      placements?: Array<ExperimentPlacement>;
    };
  };
};

export enum ExperimentVariants {
  Control = 'control',
  Treatment = 'treatment',
  NoWallpaper = 'no_wallpaper'
}
